import { ThunkAction } from 'redux-thunk'

import config from 'admin/config/main'
import { reduxDependenciesType } from 'admin/redux/create'
import { State } from 'admin/redux/ducks'
import { InvoiceRecipientType, InvoiceGroupingTypes } from 'admin/types'
import createApiReducer, {
  requestDataFor,
  receiveDataFor,
  handleErrorFor,
} from 'redux/utils/createApiDuck'
import { APIState } from 'types'

const moduleName = `${config.appName  }/invoiceRecipients`

export default createApiReducer(moduleName)

export function fetchInvoiceRecipients(
  orgAccountId: string,
): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())
    return api
      .getInvoiceRecipients(orgAccountId)
      .then(data => {
        dispatch(receiveDataFor(moduleName)(data))
        return data
      })
      .catch(error => {
        dispatch(handleErrorFor(moduleName)(error))
        return Promise.reject(error)
      })
  }
}

export function setInvoiceRecipient(
  recipient: InvoiceRecipientType,
): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName))
    return api
      .setInvoiceRecipient({
        ...recipient,
        invoiceGrouping: InvoiceGroupingTypes.PER_TRANSACTION,
      })
      .then(invoiceRecipientId => {
        dispatch(fetchInvoiceRecipients(recipient.orgAccountId))
        return invoiceRecipientId
      })
  }
}

export function inactivateInvoiceRecipient(
  invoiceRecipientId: string,
): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    return api.inactivateInvoiceRecipient(invoiceRecipientId)
  }
}

export interface InvoiceRecipientsState extends APIState {
  data: InvoiceRecipientType[] | null
}

export interface InvoiceRecipientState extends APIState {
  data: InvoiceRecipientType | null
}
